export default {"src":"/_next/static/media/externalLink_uiLight_24.6a2bd795.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};